import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="loading-spinner">
      <div className="spinner"></div>
      <style>{`
        .loading-spinner {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100px;
        }
        .spinner {
          border: 8px solid rgba(0, 0, 0, 0.1);
          border-top: 8px solid #a98017;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner; 